import React from 'react'

import Score from '../../../components/Score'
import EvacuationScore from '../../../components/EvacuationScore'
import Bar from '../../../components/Bar'
import IconTooltip  from '../../../components/IconTooltip'

export default class ScanInfo extends React.Component {

  render() {
    const { scan, phaseTotals, wheelTotals, setMode } = this.props

    return (
      <div className="col">
        <div className="block total-score" onClick={() => setMode('total')}>
          <h2>Totaalscore <IconTooltip text="<p>Dit is de totaalscore van de scan ten opzichte van de norm. Het referentie kader voor de norm is bepaald door het vaststellen van een maatgevend scenario en vervolgens te bepalen welk risico redelijkerwijs acceptabel is. Voor een toelichting hiervan, zie Account &ndash; Over BrandWijzer - Verantwoording</p>" icon='far fa-info-circle' /></h2>
          <Bar score={scan.totalScore} />
          <Score score={scan.totalScore} />
          <div className="info"><span className="info-container">Norm</span></div>
        </div>

        <div className="block">
          <h2>Score per fase <IconTooltip text="<p>Hier ziet u de scores per ontwikkelfase bij een brand, achtereenvolgens Ontstaan van brand, Brandontwikkeling en rookverspreiding, Ontruiming en Continu&#239;teit van zorg." icon='far fa-info-circle' /></h2>
          { phaseTotals.map((pt, i) =>
          <div onClick={
            () => setMode('phase', pt)}
            className={`phase-total ${ pt.score >= 0 ? 'positive' : 'negative' }`}
            key={i}>
            <Score score={pt.score} />
            <span className="phase-label">
              <span className="text">{pt.phase}</span>
              <IconTooltip id={pt.phase} icon='far fa-info-circle' />
            </span>
            { pt.score < 0 && false &&
              <span className="exclamation-mark">
                <IconTooltip warningIcon='true' text="<p>Deze alert geeft aan dat de feitelijke score op het ontstaan van brand afwijkt van de subjectieve beleving van medewerkers. Dit kan betekenen dat medewerkers de kans op brand onterecht vrij groot achten terwijl dit feitelijk niet zo is. Het kan ook betekenen dat medewerkers de kans op brand onterecht vrij klein achten terwijl dit feitelijk niet zo is (schijnveiligheid).</p>" icon='far fa-exclamation-triangle' />
              </span> }
          </div>) }
        </div>

        <EvacuationScore scan = { this.props.scan } />

        <div className="block">
          <h2>Score per stuurwielonderdeel <IconTooltip text="<p>Dit is de score per onderdeel van het Stuurwiel Risicogestuurde Brandveiligheid. Het stuurwiel toont de samenhang tussen alle risicogebieden en maatregelen. Voor een toelichting hiervan, zie Account &ndash; Over BrandWijzer - Verantwoording</p>" icon='far fa-info-circle' /></h2>
          { wheelTotals.map((wt, i) => <div onClick={() => setMode('wheel', wt)} key={i}><span className="bar-label">{wt.steeringWheel} <IconTooltip id={wt.steeringWheel} icon='far fa-info-circle' /></span> <Bar score={wt.score} /> <Score score={wt.score} /></div>) }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Analysis/components/ScanInfo.js